export default __webpack_public_path__ + "static/media/6MD61.6419ca62.jpg";